/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';

import genericReducers from '../genericReducer';
import { IReducers } from '..';
import { ICommonResponse, IStudentCultureVisiting } from '../../api/types';
import { GET_STUDENT_CULTURE_VISITINGS } from '../../actions';

export type CultureVisitingsState = ICommonResponse<IStudentCultureVisiting>;

const initialState = {
  content: [],
  loading: false,
} as ICommonResponse<IStudentCultureVisiting>;
const generic = genericReducers<CultureVisitingsState>();
const cultureVisitings: IReducers<CultureVisitingsState> = {
  [GET_STUDENT_CULTURE_VISITINGS[REQUEST]]: generic.get.request,
  [GET_STUDENT_CULTURE_VISITINGS[SUCCESS]]: generic.get.success,
  [GET_STUDENT_CULTURE_VISITINGS[FAILURE]]: generic.get.failure,
  [GET_STUDENT_CULTURE_VISITINGS[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, cultureVisitings);
